export { LoaderComponent } from './loader/loader.component';
export { LoaderStaticComponent } from './loader-static/loader-static.component';
export * from './dialogs';
export * from './banners';
